<template>
    <div class="flex flex-col gap-[30px]">
        <div v-for="(items, trade) in addons" :key="trade" class="relative pt-[30px] p-[20px] rounded-[10px] bg-[#EFEFEF]/40">
            <div class=" flex flex-col gap-[15px]">
                <span
                    class="absolute -top-[10px] left-[15px] w-max inline-block rounded-full px-[15px] py-[2px] font-lato text-[13px] text-[#fff] bg-[#9C9BBF]">{{
                        trade }}</span>
                <div class="grid grid-col-1 lg:grid-cols-2 2xl:grid-cols-3 gap-[15px]">
                    <div v-for="(plan, index) in items" :key="index" class="flex items-center gap-[10px]">
                        <img src="../../../assets/images/check-double-purple.png" alt="Check Icon"
                            class="w-[24px] h-[24px]">
                        <span class="text-[16px] font-roboto font-normal text-[#333]">{{ plan.plan_name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    components: {

    },

    props: ['addons'],

    computed: {

    },

    watch: {


    },
    data() {
        return {

        };
    },

    mounted() {
    },

    methods: {

    },
};
</script>